module.exports = __webpack_public_path__ + "static/media/pic1.4473f74f.jpg";